// Controlling prompt levels used across the app:
//   • the Goals & Targets "Add/Edit Target" dialog — supervisor picks the
//     target's Default Controlling Prompts (multi-select checkboxes), and
//   • the Cold Probe / Multi-Trial session sheets — therapist records which
//     single prompt the child needed (the target's first default is pre-selected).
//
// Single source of truth so the code list can never drift between those screens.
// `code` is what gets persisted (on iep_target.default_controlling_prompts and in
// the session data payloads); `label` is the human-readable tooltip.
export const PROMPT_LEVELS = [
  { code: 'PVP', label: 'Partial Verbal Prompt' },
  { code: 'PPP', label: 'Partial Physical Prompt' },
  { code: 'FPP', label: 'Full Physical Prompt' },
  { code: 'PGP', label: 'Partial Gestural Prompt' },
  { code: 'IND', label: 'Independent' }
];

// The prompt code a session sheet should pre-select for a target: the first of
// its default controlling prompts, or '' when none are configured (legacy behaviour).
// Kept for any single-select caller; the session sheets now use the array form below.
export const defaultPromptForTarget = (target) => {
  const list = target && target.defaultControllingPrompts;
  return Array.isArray(list) && list.length > 0 ? list[0] : '';
};

// ALL of a target's default controlling prompt codes, as a fresh array — used to
// pre-select the (multi-select) controlling-prompt control in the Cold Probe /
// Multi-Trial session sheets. Empty array when none configured (legacy behaviour).
export const defaultPromptsForTarget = (target) => {
  const list = target && target.defaultControllingPrompts;
  return Array.isArray(list) ? list.filter(Boolean) : [];
};

// Normalise a stored controlling-prompt value into an array of codes. Handles the
// new multi-select array shape AND legacy single-string records (and empty/null),
// so viewers/editors of saved session data render both without breaking.
export const toPromptCodeArray = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  return value ? [value] : [];
};

export default PROMPT_LEVELS;
